import { _ as u } from "./index742.mjs";
import { f as C } from "./index773.mjs";
import { a as I } from "./index777.mjs";
import "./index789.mjs";
import { p as _ } from "./index784.mjs";
import { i as b } from "./index791.mjs";
import { p as d } from "./index792.mjs";
import { __exports as R } from "./index790.mjs";
var T = u, $ = C, y = I, P = R, S = _, x = b, E = d;
T({ target: "Promise", stat: !0, forced: E }, {
  all: function(s) {
    var r = this, a = P.f(r), o = a.resolve, i = a.reject, l = S(function() {
      var v = y(r.resolve), e = [], n = 0, t = 1;
      x(s, function(f) {
        var p = n++, m = !1;
        t++, $(v, r, f).then(function(c) {
          m || (m = !0, e[p] = c, --t || o(e));
        }, i);
      }), --t || o(e);
    });
    return l.error && i(l.value), a.promise;
  }
});
